(function () {
    'use strict';

    angular
        .module('jotApp')
        .controller('ResetFinishController', ResetFinishController);

    ResetFinishController.$inject = ['$stateParams', '$timeout', 'Auth', '$state'];

    function ResetFinishController($stateParams, $timeout, Auth, $state) {
        var vm = this;

        vm.keyMissing = angular.isUndefined($stateParams.key);
        vm.confirmPassword = null;
        vm.doNotMatch = null;
        vm.error = null;
        vm.finishReset = finishReset;
        vm.resetAccount = {};
        vm.success = null;
        vm.checkMinLngUser = true;
        vm.passwordnotmatch = " ";

        vm.login = function () {
            $state.go('login');
        };

        $timeout(function () {
            angular.element('#password').focus();
        });

        function finishReset() {
            if (vm.resetAccount.password !== vm.confirmPassword) {
                vm.doNotMatch = 'ERROR';
            } else {
                Auth.resetPasswordFinish({
                    key: $stateParams.key,
                    newPassword: vm.resetAccount.password
                }).then(function () {
                    vm.success = 'OK';
                }).catch(function () {
                    vm.success = null;
                    vm.error = 'ERROR';
                });
            }
        }
        vm.passwordmatch = function()
        {
            if(vm.resetAccount.password === vm.confirmPassword)
                vm.passwordnotmatch = " ";
            else
                vm.passwordnotmatch = "Password does not match";
        }
        vm.checkUserLng = function() {
            vm.checkMinLngUser =  (vm.resetAccount.password !== vm.confirmPassword);
        }
    }
})();
